export var EGSLockdownLevelValue;
(function (EGSLockdownLevelValue) {
    EGSLockdownLevelValue["LVL_0"] = "LVL_0";
    EGSLockdownLevelValue["LVL_1"] = "LVL_1";
    EGSLockdownLevelValue["LVL_2"] = "LVL_2";
    EGSLockdownLevelValue["LVL_3"] = "LVL_3";
    EGSLockdownLevelValue["LVL_4"] = "LVL_4";
    EGSLockdownLevelValue["LVL_5"] = "LVL_5";
    EGSLockdownLevelValue["IGNORE"] = "IGNORE";
    EGSLockdownLevelValue["LVL_1_HOT"] = "LVL_1_HOT";
    EGSLockdownLevelValue["LVL_2_HOT"] = "LVL_2_HOT";
    EGSLockdownLevelValue["LVL_3_HOT"] = "LVL_3_HOT";
    EGSLockdownLevelValue["LVL_4_HOT"] = "LVL_4_HOT";
    EGSLockdownLevelValue["LVL_5_HOT"] = "LVL_5_HOT";
    EGSLockdownLevelValue["LVL_3_ADV"] = "LVL_3_ADV";
})(EGSLockdownLevelValue || (EGSLockdownLevelValue = {}));
export var EGSLockdownLevelGeoSheetTitle;
(function (EGSLockdownLevelGeoSheetTitle) {
    EGSLockdownLevelGeoSheetTitle["geolevels"] = "geolevels";
    EGSLockdownLevelGeoSheetTitle["input"] = "input";
    EGSLockdownLevelGeoSheetTitle["lvl_type_ref"] = "lvl_type_ref";
})(EGSLockdownLevelGeoSheetTitle || (EGSLockdownLevelGeoSheetTitle = {}));
